import React, { useState } from 'react';
import axios from 'axios';
import './uploadModal.css';

const UploadDocumentModal = ({ isOpen, onClose, onUploadSuccess, folderId }) => {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [progress, setProgress] = useState(0);
  let progressInterval = null;

  if (!isOpen) return null;

  const triggerFileInput = () => document.getElementById('fileInput').click();

  const startProgress = () => {
    progressInterval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 90) {
          return prevProgress + 1;
        } else {
          clearInterval(progressInterval);
          return prevProgress;
        }
      });
    }, 100);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setIsUploading(true);
    setIsUploaded(false);
    setProgress(0);
    startProgress();
    handleFileUpload(selectedFile);
  };

  const handleFileUpload = async (selectedFile) => {
    const token = localStorage.getItem('token');

  

    if (!selectedFile || !folderId) {
      alert('No file selected or folder ID missing.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const url = `${process.env.REACT_APP_API_URL}api/v1/readpdf/upload-in-folder/${folderId}/`;
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Token ${token}`,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.min(
            Math.round((progressEvent.loaded * 100) / progressEvent.total),
            90
          );
          setProgress(percentCompleted);
        },
      });

      if (response.status === 200) {
        clearInterval(progressInterval);
        setTimeout(() => {
          setProgress(100);
          setTimeout(() => {
            setIsUploaded(true);
            setIsUploading(false);
            onUploadSuccess(); 
          }, 1000);
        }, 500);
      } else {
        alert(response.data.msg || 'File upload failed');
        setIsUploading(false);
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert(
        error.response?.data.msg || 'An error occurred during file upload. Please try again.'
      );
      setIsUploading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-overlay-details">
      <div className="modal-content-details">
        <button className="close-button" onClick={handleClose}>
          <img src="/cross.svg" alt="" />
        </button>

        {isUploaded ? (
          <div>
            <div className="success-status">
              <div className="success-icon">
                <img src="./right-success.svg" alt="Success Icon" className="checkmark-icon" />
              </div>
              <h3 className="success-heading">File Uploaded Successfully</h3>
              <p className="success-message">Your file has been uploaded successfully.</p>
              <div className="file-info">
                <span className="file-name-icon">
                  <img src="file-icon.svg" alt="" />
                </span>
                <span className="file-name">{file ? file.name : 'Uploaded_File.pdf'}</span>
              </div>
            </div>
            <button className="view-details-button" onClick={handleClose}>
              Done
            </button>
          </div>
        ) : isUploading ? (
          <div className="uploading-state">
            <h3>Uploading Your Document</h3>
            <p>Your document is being uploaded, please wait.</p>
            <p>{progress}% completed</p>
            <div className="progress-bar">
              <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
            </div>
          </div>
        ) : (
          <div className="upload-box" onClick={triggerFileInput}>
            <input
              type="file"
              id="fileInput"
              style={{ display: 'none' }}
              onChange={handleFileChange}
                  accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.webp,.bmp"

            />
            <div className="upload-icon">
              <img src="./uploadBig.svg" alt="Upload Icon" className="upload-big" />
            </div>
            <p>Drag and drop files here or click to upload.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadDocumentModal;
